// extracted by mini-css-extract-plugin
export default {"countdown":"Countdown_countdown__cQy7J","urgent":"Countdown_urgent__KwYUv","hideLozenge":"Countdown_hideLozenge__GUFMr"};